import { Component, OnInit } from '@angular/core';
import { UtilityService } from 'src/app/modules/accounts-module/accounts/services/utility-service';
import { PromoSmsModel } from '../../models/promo-sms-mode';
import { MatTableDataSource } from '@angular/material/table';
import { TemplateMasterService } from '../../services/template-master-service';
import { Template } from '../../models/template-model';
import { CustomerModel } from '../../models/customer-model';
import { CustomerMasterService } from '../../services/customer-master-service';
import { PromoSMSService } from '../../services/promo-sms-service';

@Component({
  selector: 'app-promo-msg-scheduler',
  templateUrl: './promo-msg-scheduler.component.html',
  styleUrls: ['./promo-msg-scheduler.component.css']
})
export class PromoMsgSchedulerComponent implements OnInit {

    public l_formData: PromoSmsModel = new PromoSmsModel();
    private l_clientId: number;
  
    public dataSource = new MatTableDataSource<PromoSmsModel>();
    public l_promoList: PromoSmsModel[] = [];
    public displayedColumns: string[] = [
      'templateName',
      'customerName',
      'promoSmsScheduledOn',
      'isActive'
    ];

    public l_templatesList: Template[] = [];
    public customerList: CustomerModel[] = [];

  constructor(
    private l_UtilityService: UtilityService,
    private l_TemplateMasterService: TemplateMasterService,
    private l_CustomerMasterService: CustomerMasterService,
    private l_PromoSMSService: PromoSMSService
  ) { }

  async ngOnInit() {
    const data = JSON.parse(sessionStorage.getItem('client_master'));
    this.l_clientId = data.clientId;
    // Defaults
    this.l_formData.isActive = 'YES';
    await this.lFN_GetTemplateList();
    await this.lFN_GetCustomerList();
    await this.lFN_GetPromoSmsScheduledList();
  }

  async lFN_GetPromoSmsScheduledList() {
    this.l_UtilityService.lFN_ShowLoader();
    let l_response = this.l_PromoSMSService.lFN_GetPromoSMSServiceList();
    l_response.subscribe({
      next: (res) => {
        console.log("res => ", res);
        this.dataSource.data = JSON.parse(res.body)?.data;
        this.l_UtilityService.lFN_HideLoader();
      },
      error: () => {
        this.l_UtilityService.lFN_ErrorToaster(
          'Failed to load Promo SMS scheduled list',
          'Error'
        );
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }  

  async lFN_GetTemplateList() {
    let l_response = this.l_TemplateMasterService.lFN_GetTemplateMasterList();
    l_response.subscribe({
      next: (res) => {
        console.log("res => ", res);
        this.l_templatesList = JSON.parse(res.body)?.data;
      },
      error: () => {
        this.l_UtilityService.lFN_ErrorToaster(
          'Failed to load template list',
          'Error'
        );
      }
    });
  }

  async lFN_GetCustomerList() {
    this.l_CustomerMasterService.lFN_GetCustomerList().subscribe({
      next: (res: any) => {
        this.customerList = JSON.parse(res.body)?.data;
      },
      error: () => {
        this.l_UtilityService.lFN_ErrorToaster(
          'Failed to load customer list',
          'Error'
        );
      }
    });
  }

  async lFN_SubmitForm() {
    console.log("l_formData => ", this.l_formData);
    let l_formDataObject = this.l_formData;
    if (l_formDataObject.templateId == null || l_formDataObject.customerId == null || l_formDataObject.promoSmsScheduledOn == null) {
      this.l_UtilityService.lFN_WarningToaster('Please select required values to save', 'Required fields missing');
      return;
    }

    // set clientID
    l_formDataObject.clientId = this.l_clientId;

    this.l_UtilityService.lFN_ShowLoader();
    let l_response = this.l_PromoSMSService.lFN_SavePromoSMSService(l_formDataObject);
    l_response.subscribe({
      next: async (response) => {
        console.log("response = ", response);
        if (response.status == 200) {
          this.l_UtilityService.lFN_SuccessToaster((response.body as any)?.message, 'Success');
          await this.lFN_GetPromoSmsScheduledList();
        }
      },
      error: () => {
        this.l_UtilityService.lFN_ErrorToaster(
          'Failed to schedule Promo SMS',
          'Error'
        );
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
        this.l_formData = new PromoSmsModel();
      }
    });
  }

  lFN_ResetForm() {
    this.l_formData = new PromoSmsModel();
  }

  lFN_ChangePromoSmsStatus(l_promoSmsObject: PromoSmsModel) {
    const newStatus = !l_promoSmsObject.isActive;
    const statusLabel = newStatus ? 'Active' : 'Inactive';

    const dialogData = {
      title: `Change Promo SMS Status - ${ l_promoSmsObject.promoSmsName }`,
      message: `Are you sure you want to change status of ${ l_promoSmsObject.promoSmsName } to ${ statusLabel }?`,
      buttons: [
        {
          label: 'Yes',
          value: true,
          color: 'primary',
          className: 'btn-yes-custom',
        },
        { label: 'No', value: false, color: 'warn' },
      ],
    };

    this.l_UtilityService
      .lFN_ShowConfirmationDialog(
        dialogData.title,
        dialogData.message,
        dialogData.buttons
      )
      .subscribe((confirmed) => {
        if (!confirmed) return;

        this.l_PromoSMSService.lFN_TogglePromoServiceStatus(l_promoSmsObject.promoSmsLogId).subscribe({
          next: async (response: any) => {
            l_promoSmsObject.isActive = (newStatus ? 'YES' : 'NO');
            this.l_UtilityService.lFN_SuccessToaster(response?.body?.msg || 'Promo SMS status changed successfully',
              'Success'
            );
            await this.l_PromoSMSService.lFN_GetPromoSMSServiceList();
          },
          error: (err) => {
            const errorMsg = err.error?.msg || 'Failed to change Promo SMS status';
            this.l_UtilityService.lFN_ErrorToaster(errorMsg, 'Error');
          },
        });
      });
  }

}
